<div>

  <div class="p-heade1"></div>


  <div class="page-container container-fluid p-3" fxLayout="column">

    <h1>Quick Quotes</h1>

    <p>Submit customer account list to request an instant freepoint Quick Quote</p>
    <ng-container *ngIf="requestForm">
      <div class="main-con" fxLayout="column" [formGroup]="requestForm">
      <table class="details-table w-100" fxFlex="100" cellpadding="0">
        <thead>
        <tr [ngClass]="{'market-table': !selectedMarket, 'pjm-table': selectedMarket == 'PJM', 'ercot-table': selectedMarket == 'ERCOT'}">
          <ng-container *ngFor="let arrItem of requestFormData">
            <th *ngIf="arrItem.type !== 'input' && (!arrItem.showOnMarket || arrItem.showOnMarket == selectedMarket)">
              <span>{{arrItem.type == 'button' ? '&#x00A0;' :arrItem.label}}</span>
            </th>
            <th *ngIf="arrItem.type !== 'input' && arrItem.showOnMarket && !selectedMarket">
              <span>&#x00A0;</span>
            </th>
          </ng-container>
          </tr>
        </thead>
        <tbody>
        <tr [ngClass]="{'market-table': !selectedMarket, 'pjm-table': selectedMarket == 'PJM', 'ercot-table': selectedMarket == 'ERCOT'}">
          <ng-container *ngFor="let arrItem of requestFormData; let formInd = index">
           <td *ngIf="arrItem.type !== 'input' && (!arrItem.showOnMarket || arrItem.showOnMarket == selectedMarket)">
            <ng-container *ngIf="arrItem.type == 'text'">
              {{getValue(arrItem.field)}}
            </ng-container>
            <ng-container *ngIf="arrItem.type == 'text-date'">
              {{getValue(arrItem.field) | date: "MM/dd/YYYY"}}
            </ng-container>
            <mat-form-field *ngIf="arrItem.type == 'select' && !arrItem.apiOptions" appearance="outline" class="w-100">
              <mat-select [disabled]="(arrItem.disableOnValue && getValue(arrItem.field) && !arrItem.disableDependent) || arrItem.disableDependent && getValue(arrItem.disableDependent).length || false" [formControlName]="arrItem.field">
                <mat-option *ngFor="let option of (arrItem.dependency ? arrItem.options[getValue(arrItem.dependency)] || []: arrItem.options)" [value]="option.value || option">
                  {{option.label || option}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="arrItem.type == 'select' && arrItem.apiOptions">
              <app-async-select [selectorId]="'asyncSelector-'+formInd"  [disabled]="(arrItem.disableOnValue && getValue(arrItem.field) && !arrItem.disableDependent) || arrItem.disableDependent && getValue(arrItem.disableDependent).length || false" [selectControl]="requestForm && requestForm.get(arrItem.field)" [field]="arrItem.field" [apiInfo]="arrItem.apiOptions" [dependency]="arrItem.dependency ? getValue(arrItem.dependency): ''" (optionSelected)="asyncOptionSelected($event, arrItem.field)"></app-async-select>
            </ng-container>
            <mat-form-field *ngIf="arrItem.type == 'string'"  appearance="outline" class="w-100" floatLabel="always">
              <input matInput type="text" [formControlName]="arrItem.field">
            </mat-form-field>
            <mat-form-field *ngIf="arrItem.type == 'textarea'"  appearance="outline" class="w-100" floatLabel="always">
              <textarea matInput rows="3" [formControlName]="arrItem.field"></textarea>
              <mat-hint style="color: orange" *ngIf="arrItem.field === 'accountNumbers' && accountLength[selectedPjmUtility]">{{accountLength[selectedPjmUtility].description}}</mat-hint>
            </mat-form-field>
            <mat-form-field *ngIf="arrItem.type == 'date'" appearance="outline" floatLabel="always" class="w-100">
              <input matInput [matDatepicker]="picker" [max]="selectedMarket == 'PJM' ? pjmEndDate: ercotEndDate" [formControlName]="arrItem.field">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
  <!--          <button mat-raised-button type="button" class="w-100" color="primary" *ngIf="arrItem.type == 'button'" (click)="">{{arrItem.label}}</button>-->
          </td>
            <td *ngIf="arrItem.type !== 'input' && arrItem.showOnMarket && !selectedMarket">
              <span>&#x00A0;</span>
            </td>
          </ng-container>
        </tr>
        </tbody>
      </table>
        <div class="w-25 p-1">
          <label>Opportunity Name</label>
          <mat-form-field appearance="outline" class="w-100" floatLabel="always">
            <input matInput type="text" formControlName="opportunityName">
          </mat-form-field>
        </div>
      </div>
<!--      <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>-->
<!--      <div class="=action-btns mb-2" fxLayout="row" fxLayoutAlign="end">-->
<!--        <button class="btn" type="button" mat-raised-button color="primary" (click)="calculateQuote()"-->
<!--                [disabled]="requestForm.invalid"-->
<!--        >-->
<!--          Calculate-->
<!--        </button>-->
<!--      </div>-->
      <div>
        <div *ngIf="selectedMarket ==='PJM'">
          <div *ngIf="false;else pjm_content"></div>
        </div>
        <div *ngIf="selectedMarket ==='ERCOT'">
          <div *ngIf="false;else ercot_content"></div>
        </div>
      </div>
    </ng-container>

    <div style="margin-top: 40px">
      <h3 style="color:#003056" (click)="openContractGenDialog()">FREEPOINT CONTRACT TEMPLATES</h3>
      <ul *ngIf="selectedMarket==='PJM'">
        <li (click)="downloadFile('PJM_IL_Standard.docx')"><span class="download-link">IL Matrix Contract</span></li>
        <li (click)="downloadFile('PJM_PA_Standard.docx')"><span class="download-link">PA Matrix Contract</span></li>
      </ul>
      <ul *ngIf="selectedMarket==='ERCOT'">
        <li (click)="downloadFile('TX_Standard.docx')"><span class="download-link">TX - Matrix Contract</span>
        </li>
        <li (click)="downloadFile('TX-SCOM-_YRAC.docx')"><span class="download-link">TX - SCOM_YRAC</span></li>

        <li *ngIf="selectedErcotUtility=='AEP_TX_TCC'" (click)="downloadFile('TX-AEP-Texas-Central-SCOM_EFL.docx')"
        ><span class="download-link">AEP TX TCC</span>
        </li>
        <li *ngIf="selectedErcotUtility=='AEP_TX_TNC'" (click)="downloadFile('TX-AEP-Texas-North-SCOM_EFL.docx')"
        ><span class="download-link">AEP TX TNC</span>
        </li>
        <li *ngIf="selectedErcotUtility=='Centerpoint'" (click)="downloadFile('TX-Centerpoint-SCOM_EFL.docx')"
        ><span class="download-link">Centerpoint</span>
        </li>
        <li *ngIf="selectedErcotUtility=='Oncor'" (click)="downloadFile('TX-Oncor-SCOM_EFL.docx')"
        ><span class="download-link">Oncor</span>
        </li>
        <li *ngIf="selectedErcotUtility=='TNMP'" (click)="downloadFile('TX-TNMP-SCOM_EFL.docx')">
          <span class="download-link">TNMP</span>
        </li>
      </ul>

    </div>
    <div class="hd pl-3 mb-3">
      FREEPOINT PRICING GUIDELINES
    </div>
    <div class="row" style="width: 100% ">
      <div class="col-sm-12 col-lg-6">
        <h4 class="font-weight-bold">Contract Submission Instructions</h4>
        <ul>
          <li>Submit contract to contracts@freepointsolutions.com</li>
          <li>Please forward the Pricing Confirmation email</li>
          <li>Please include the signed contract and a recent bill</li>
          <li>Please clearly indicate the term and expected broker fee</li>
        </ul>
        <h3 class="font-weight-bold">Support</h3>
        <ul>
          <li>For system questions, issues, access or other assistance please contact sales@freepointsolutions.com</li>
          <li>Recommended browsers – The latest two versions of Chrome, Firefox, Microsoft Edge, and Safari are
            supported
          </li>
        </ul>
      </div>

      <div class="col-sm-12 col-lg-6">
        <h3 class="font-weight-bold">Price</h3>
        <ul>
          <li>Prices are good for today only</li>
          <li>Taxes</li>
          <ul>
            <li>SUT (NJ), CAT (OH) – Included</li>
            <li>GRT (PA) – Included</li>
          </ul>
          <li>Prices apply only for contract length, rate class and utilities specified above</li>
          <li>All contracts must be accompanied by utility bill from the prior 60 days</li>
          <ul>
            <li>Bills with outstanding balances risk being rejected for credit</li>
          </ul>
          <li>Multi-account submissions must be by uniform rate class, utility and contract length, not to exceed 20
            accounts
          </li>
          <li>Each price submission should be by individual customer/contracting entity</li>
          <li>For other price requests please contact Freepoint for custom pricing</li>
        </ul>

      </div>


    </div>
    <div class="hd pl-3 mb-3">
      ADDITIONAL DETAILS
    </div>
    <div class="row" style="width: 100% ">
      <div class="col-sm-12 col-lg-12">
        <ul>
          <li>Contracts must be received before 4:00PM (Eastern Prevailing Time)</li>
          <li>Freepoint does not accept price submissions for Protected Class Customers* in Delaware or Illinois</li>
          <li>Contracts will be reviewed for compliance by state and customer class and will be rejected if they fail to
            meet required thresholds
          </li>
          <li>Freepoint reserves the right to reject contracts in its sole discretion, including for incomplete or
            inaccurate submissions, non-compliance with the guidelines listed above, market movements or credit reasons.
            Each deal is subject to Freepoint’s review and approval. No contract will become binding and effective until
            executed by an authorized representative of Freepoint.
          </li>
          <li>Protected Class Customers – Please refer to Freepoint’s contract for details</li>
          <li style="color:#ff0000">Tax identification numbers are required for all small commercial contracts in ERCOT. Contracts without a tax identification number will not be countersigned or booked.</li>
        </ul>
      </div>
    </div>

    <div class="row" style="width: 100% ">
      <div class="col-sm-12 col-lg-12">
        <h3 class="font-weight-bold">TERMS AND CONDITIONS</h3>
        <ul>
          <li>This web portal is for the sole use of licensed brokers who are acting as customers’ authorized agents. To
            provide a pricing quote Freepoint will access customer-related data, which may include confidential Utility
            data. Do not make a pricing request, if you do not have the appropriate authorization from the customer for
            whom the request is made.
          </li>
          <li>Depending on the Utility, in order to access information on this web portal, you must first acknowledge
            that you are the agent of the customer(s) for whom the pricing request is made and have verifiable authority
            from the applicable customer to consent to the release of its account-related information to Freepoint.
          </li>
          <li>If applicable, you will also be asked to acknowledge (by clicking on a checkbox above) that you, acting as
            the customer’s agent, authorize Freepoint Energy Solutions LLC., its affiliates and agents (together
            “Freepoint”) to request and receive information from the applicable utility(ies) for the account(s) listed
            above, including, without limitation, billing information, historical usage, interval usage data (if
            available), capacity and/or transmission data, rate class, billing determinants and load profile
            information.
          </li>
          <li>By accessing and/or using this web site, you also agree to review Freepoint’s Privacy Policy and Terms and
            Conditions by clicking the links at the bottom of this page.
          </li>
          <li>Freepoint reserves the right to investigate complaints or reported violations of these Terms and
            Conditions and to take any actions it deems appropriate, including but not limited to reporting any
            suspected unlawful activity to law enforcement officials, regulators, or other third parties and disclosing
            any information necessary or appropriate to such persons or entities relating to user profiles, e-mail
            addresses, use history, IP addresses and traffic information.
          </li>
          <li>Do not use this web portal if any of these Terms and Conditions are not acceptable to you.</li>

        </ul>
      </div>
    </div>


  </div>

</div>


<ng-template #pjm_content>
<!--  <div class="row hd m-0" style="width: 100%">-->
<!--    <div class="col-sm-12 col-lg-2">-->
<!--      MARKET-->
<!--    </div>-->

<!--    <div class="col-sm-12 col-lg-4">-->
<!--      UTILITY-->
<!--    </div>-->
<!--    <div class="col-sm-12 col-lg-3">-->
<!--      ACCOUNT NUMBER-->

<!--    </div>-->

<!--    <div class="col-sm-12 col-lg-3">-->
<!--      START DATE-->

<!--    </div>-->

<!--  </div>-->
  <div class="row m-0" style="width: 100%;background-color: #003056">
<!--    <div class="col-sm-12 col-lg-2 mb-4">-->
<!--      <div class="row" style="width: 100% ">-->
<!--        <div class="col-sm-12 col-lg-12">-->
<!--          <div class="item" (click)="selectMarket('PJM')"-->
<!--               [ngClass]="{'selected-item' : (selectedMarket=='PJM') ,'item':true}">-->
<!--            PJM-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-sm-12 col-lg-12">-->
<!--          <div class="item" (click)="selectMarket('ERCOT')"-->
<!--               [ngClass]="{'selected-item' : (selectedMarket=='ERCOT') ,'item':true}">-->
<!--            ERCOT-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->

<!--    </div>-->

<!--    <div class="col-sm-12 col-lg-3 mb-4">-->
<!--      <div class="row" style="width: 100% ">-->

<!--        <div class="col-sm-12 col-lg-12" *ngFor="let util of pjmUtilities">-->
<!--          <div class="pjm-utility"-->
<!--               [ngClass]="{'selected-item' : (selectedPjmUtility==util.code ) ,'item':true}"-->
<!--               (click)="selectPjmUtility(util)">-->
<!--            {{util.text}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->


<!--    </div>-->

<!--    <div class="col-sm-12 col-lg-4 mb-4">-->
<!--        <textarea class="form-control" rows="5" id="comment" [(ngModel)]="pjmAccounts" (ngModelChange)="pjmError=''"-->
<!--                  placeholder="Account Numbers"></textarea>-->

<!--      <p style="margin-top: 10px;color: orange"-->
<!--         *ngIf="accountLength[selectedPjmUtility]">{{accountLength[selectedPjmUtility].description}}</p>-->
<!--    </div>-->


<!--    <div class="col-sm-12 col-lg-3 mb-4">-->
<!--      <div class="row" style="width: 100%;height: 30vh;overflow-y: auto ">-->

<!--        <div class="col-sm-12 col-lg-12" *ngFor="let startDate of pjmStartDateList">-->
<!--          <div class="pjm-start-date"-->
<!--               [ngClass]="{'selected-item' : (selectedPjmStartDate==startDate.code ) ,'item':true}"-->
<!--               (click)="selectedPjmStartDate = startDate.code">-->
<!--            {{startDate.text}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
<!--    <div class="p-3">-->
<!--      <label for="opt" style="color: white">Opportunity Name</label>-->
<!--      <input mdbInput type="text" id="opt" [(ngModel)]="pjmOpportunityName" class="form-control">-->
<!--    </div>-->
    <mat-progress-bar *ngIf="pjmLoading" mode="indeterminate"></mat-progress-bar>
  </div>

  <div class="row m-0" style="width: 100%;margin-top: 20px">
    <div class="col-sm-12 col-lg-10" style="overflow-x: auto">
      <div *ngIf="selectedPjmUtility && selectedPjmUtility != 'ComEd'">
        <mat-checkbox [(ngModel)]="confirmAgreement" color="primary">
          I am the authorized agent of the customer for whom the pricing request is made.
        </mat-checkbox>
        <div>
          I authorize Freepoint to access customer’s account information from the applicable Utility.<br>
          I have read, understand and agree to the Terms and Conditions below.<br>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-lg-2">
      <button type="button" mat-raised-button (click)="calculatePjm()" class="btn-cal"
              *ngIf="((confirmAgreement && selectedPjmUtility != 'ComEd')   || selectedPjmUtility == 'ComEd')
                && selectedPjmUtility && selectedPjmStartDate && pjmAccounts &&  !pjmLoading "
      >
        Calculate
      </button>
    </div>

  </div>


  <div style=" margin-top: 20px">
    <div *ngIf="pjmError" [innerHTML]="pjmError" style="color: orangered">

    </div>
    <div style="color: orangered" *ngIf="wrongAccountNumbers.length > 0">
      <p *ngIf="wrongAccountNumbers.length == 1">Below account is incorrect:</p>
      <p *ngIf="wrongAccountNumbers.length > 1">Below accounts are incorrect:</p>
      <ul>
        <li *ngFor="let accountNumber of wrongAccountNumbers">
          {{accountNumber}}
        </li>
      </ul>
    </div>
  </div>
  <div class="pjm-result " *ngIf="showPjmResult">
    <mat-card style="background-color: #f6f7f9 !important;">
      <h3>PRICE ($/kWh)</h3>
      <table class="table">
        <thead>
        <tr>

          <th>Start Month</th>
          <th>Month 6</th>
          <th>Month 12</th>
          <th>Month 18</th>
          <th>Month 24</th>
          <th>Month 36</th>
          <th>Month 48</th>
          <th>Month 60</th>
        </tr>
        </thead>
        <tbody>
        <tr>
           <td>{{pjmCalculationResult.startDate}}</td>
          <td>{{formatPjmPrice(pjmCalculationResult.month6)}}</td>
          <td>{{formatPjmPrice(pjmCalculationResult.month12)}}</td>
          <td>{{formatPjmPrice(pjmCalculationResult.month18)}}</td>
          <td>{{formatPjmPrice(pjmCalculationResult.month24)}}</td>
          <td>{{formatPjmPrice(pjmCalculationResult.month36)}}</td>
          <td>{{formatPjmPrice(pjmCalculationResult.month48)}}</td>
          <td>{{formatPjmPrice(pjmCalculationResult.month60)}}</td>
        </tr>
        </tbody>
      </table>

    </mat-card>
    <div class="float-right mt-3">
      <button type="button" mat-raised-button class="btn-cal" (click)="openContractGenDialog()">Download Contract
      </button>
    </div>
  </div>
</ng-template>
<ng-template #ercot_content>
<!--  <div class="row hd m-0" style="width: 100%">-->
<!--    <div class="col-sm-12 col-lg-2">-->
<!--      MARKET-->
<!--    </div>-->
<!--    <div class="col-sm-12 col-lg-2">-->
<!--      UTILITY-->
<!--    </div>-->
<!--    <div class="col-sm-12 col-lg-2">-->
<!--      ZONE-->
<!--    </div>-->
<!--    <div class="col-sm-12 col-lg-2">-->
<!--      LOAD TYPE-->
<!--    </div>-->
<!--    <div class="col-sm-12 col-lg-2">-->
<!--      KWH / YEAR-->
<!--    </div>-->

<!--    <div class="col-sm-12 col-lg-2">-->
<!--      START DATE-->
<!--    </div>-->
<!--  </div>-->

  <div class="row" style="width: 100%;background-color: #003056">
<!--    <div class="col-sm-12 col-lg-2 mb-4">-->
<!--      <div class="row" style="width: 100% ">-->
<!--        <div class="col-sm-12 col-lg-12">-->
<!--          <div class="item" (click)="selectMarket('PJM')"-->
<!--               [ngClass]="{'selected-item' : (selectedMarket=='PJM') ,'item':true}">-->
<!--            PJM-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-sm-12 col-lg-12">-->
<!--          <div class="item" (click)="selectMarket('ERCOT')"-->
<!--               [ngClass]="{'selected-item' : (selectedMarket=='ERCOT') ,'item':true}">-->
<!--            ERCOT-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="col-sm-12 col-lg-2 mb-4">-->
<!--      <div class="row" style="width: 100% ">-->
<!--        <div class="col-sm-12 col-lg-12" *ngFor="let util of ercotUtilityList">-->
<!--          <div class="item"-->
<!--               [ngClass]="{'selected-item' : (selectedErcotUtility==util.code ) ,'item':true}"-->
<!--               (click)="selectErcotUtility(util)">-->
<!--            {{util.text}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-sm-12 col-lg-2 mb-4">-->
<!--      <div class="row" style="width: 100% ">-->
<!--        <div class="col-sm-12 col-lg-12" *ngFor="let zone of ercotZoneList">-->
<!--          <div class="item"-->
<!--               [ngClass]="{'selected-item' : (selectedErcotZone==zone.code ) ,'item':true}"-->
<!--               (click)="selectErcotZone(zone)">-->
<!--            {{zone.text}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-sm-12 col-lg-2 mb-4">-->
<!--      <div class="row" style="width: 100% ">-->
<!--        <div class="col-sm-12 col-lg-12" *ngFor="let loadType of ercotLoadTypeList">-->
<!--          <div class="item"-->
<!--               [ngClass]="{'selected-item' : (selectedErcotLoadType==loadType.code ) ,'item':true}"-->
<!--               (click)="selectedErcotLoadType = loadType.code">-->
<!--            {{loadType.text}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-sm-12 col-lg-2 mb-4">-->
<!--      <div class="row" style="width: 100% ">-->
<!--        <div class="col-sm-12 col-lg-12" *ngFor="let kwh of ercotKwhYearlist">-->
<!--          <div class="item"-->
<!--               [ngClass]="{'selected-item' : (selectedErcotKwhYear==kwh.code ) ,'item':true}"-->
<!--               (click)="selectedErcotKwhYear = kwh.code">-->
<!--            {{kwh.text}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-sm-12 col-lg-2 mb-4">-->
<!--      <div class="row" style="width: 100%;height: 30vh;overflow-y: auto ">-->
<!--        <div class="col-sm-12 col-lg-12" *ngFor="let startDate of ercotStartDateList">-->
<!--          <div class="item"-->
<!--               [ngClass]="{'selected-item' : (selectedErcotStartDate==startDate.code ) ,'item':true}"-->
<!--               (click)="selectedErcotStartDate = startDate.code">-->
<!--            {{startDate.text}}-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="p-3">-->
<!--      <label for="form1" style="color: white">Opportunity Name</label>-->
<!--      <input mdbInput [(ngModel)]="ercotOpportunityName" type="text" id="form1" class="form-control">-->
<!--    </div>-->
    <mat-progress-bar *ngIf="ercotLoading" mode="indeterminate"></mat-progress-bar>
  </div>


  <div class="row m-0">
    <div class="col-sm-12 col-lg-10">
      <div class="zip-cdode-lookup">
        <p>Zip to Zone Lookup</p>
        <mat-form-field appearance="fill">
          <mat-label>Zip Code</mat-label>
          <input matInput type="text" [(ngModel)]="zipCode">
          <button *ngIf="zipCode" matSuffix mat-icon-button aria-label="Clear" (click)="zipCode=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <div style="height: 40px;padding-top:10px" id="texas_zone">
          {{zoneByZip[zipCode]}}
        </div>
      </div>

    </div>

    <div class="col-sm-12 col-lg-2">

      <div style=" margin-top: 25px">

        <button type="button" mat-raised-button color="primary" (click)="calculateErcot()" class="btn-cal"
                *ngIf="!ercotLoading &&  selectedErcotUtility && selectedErcotZone &&  selectedErcotLoadType && selectedErcotKwhYear && selectedErcotStartDate"
        >
          Calculate
        </button>
      </div>
    </div>


  </div>


  <div style=" margin-top: 20px" *ngIf="ercotError">
    <div [innerHTML]="ercotError" style="color: orangered"></div>

  </div>
  <div class="ercot-result " *ngIf="showErcotResult">
    <mat-card style="background-color: #f6f7f9 !important;">
      <h3>PRICE (¢/KWH)</h3>
      <table class="table">
        <thead>
        <tr>
          <th colspan="8" class="header1"></th>
          <th colspan="3" class="header2">Sweet Spot Pricing</th>
        </tr>
        <tr>
          <th>Start Month</th>
          <th>Month 6</th>
          <th>Month 12</th>
          <th>Month 18</th>
          <th>Month 24</th>
          <th>Month 36</th>
          <th>Month 48</th>
          <th>Month 60</th>
          <th>Term</th>
          <th>Pricing</th>
          <th>End Month</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ercotCalculationResult.startDate}}</td>
          <td>{{formatErcotPrice(ercotCalculationResult.month6)}} </td>
          <td>{{formatErcotPrice(ercotCalculationResult.month12)}}</td>
          <td>{{formatErcotPrice(ercotCalculationResult.month18)}}</td>
          <td>{{formatErcotPrice(ercotCalculationResult.month24)}}</td>
          <td>{{formatErcotPrice(ercotCalculationResult.month36)}}</td>
          <td>{{formatErcotPrice(ercotCalculationResult.month48)}}</td>
          <td>{{formatErcotPrice(ercotCalculationResult.month60)}}</td>
          <td>{{ercotCalculationResult.sweetTerm}} Months</td>
          <td>{{formatErcotPrice(ercotCalculationResult.sweetPrice)}} </td>
          <td>{{ercotCalculationResult.sweetEndDate}}</td>
        </tr>
        </tbody>
      </table>

    </mat-card>
    <div class="float-right mt-3">
      <button type="button" mat-raised-button class="btn-cal" (click)="openContractGenDialog()">Download Contract
      </button>
    </div>
  </div>
</ng-template>
